module.exports = __webpack_public_path__ + "static/bottom-right-6c3a79112f23802c22c4d0922cc9628a.png";